import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface MailStopDoneState {
  result: boolean
}

export const initialState: MailStopDoneState = {
    result: false,
};

export const MailStopDoneReducer = reducerWithInitialState(initialState).case(
  actions.fetchMailStopDone,
  (state: MailStopDoneState, payload: MailStopDoneState) => {
    return payload;
  }
);
